/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SocialLinkRow_viewer$ref = any;
export type SocialLinkRow_viewer = {
    readonly isDownloadAppEnabled: boolean | null;
    readonly " $refType": SocialLinkRow_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SocialLinkRow_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isDownloadAppEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DOWNLOAD_APP"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DOWNLOAD_APP\")"
    }
  ]
};
(node as any).hash = '16814f30880528c32ed2f14cff2133fe';
export default node;
